/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './setup-settings-admin.scss';

/* eslint-disable import/no-unresolved, import/default */

import setupSettingsAdminTemplate from './setup-settings-admin.tpl.html';
import addSetupSettingsTemplate from './add-setup-settings.tpl.html';


/* eslint-enable import/no-unresolved, import/default */


export default angular.module('agrolog.admin.setupSettings', [])
    .directive('agSetupSettingsAdmin', SetupSettingsAdmin)
    .name;

/*@ngInject*/
function SetupSettingsAdmin() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SetupSettingsAdminController,
        controllerAs: 'vm',
        templateUrl: setupSettingsAdminTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SetupSettingsAdminController($rootScope, $scope, $translate, $document, $window, $mdMedia, $mdDialog, $filter, agTypes, assetService, userService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';

    vm.tenantAssets = [];
    vm.tenantAssetsCount = 0;
    vm.allTenantAssets = [];

    vm.displayPagination = true;
    vm.currentTenantAsset = null;

    vm.query = {
        order: 'name',
        limit: 5,
        page: 1,
        search: null
    };

    vm.addDeviceAction = {
        name: 'ag.setup-settings.add-tenant',
        show: true,
        onAction: function ($event) {
            vm.addTenantAsset($event);
        },
        icon: 'add'
    };

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function () {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.refreshAction = {
        name: 'action.refresh',
        show: true,
        onAction: function () {
            vm.reloadTenantAssets();
        },
        icon: 'refresh'
    };

    vm.onRowClick = onRowClick;
    vm.isCurrent = isCurrent;
    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onReorder = onReorder;
    vm.onPaginate = onPaginate;
    vm.addTenantAsset = addTenantAsset;
    vm.reloadTenantAssets = reloadTenantAssets;
    vm.updateTenantAssets = updateTenantAssets;

    $scope.$watch(function () {
        return $mdMedia('gt-xs');
    }, function (isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [5, 10, 15];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.ctx', function () {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetActions = [vm.addDeviceAction, vm.searchAction, vm.refreshAction];
            vm.ctx.widgetTitle = $translate.instant('ag.setup-settings.tenant-assets') + '';
            vm.displayPagination = angular.isDefined(vm.ctx.settings.displayPagination) ? vm.ctx.settings.displayPagination : true;
            reloadTenantAssets();
        }
    });

    $scope.$on('editModeChanged', function () {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$watch("vm.query.search", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateTenantAssets();
        }
    });

    $scope.$on('reloadTenantAssets', function () {
        reloadTenantAssets();
    });

    function onRowClick($event, tenant) {
        if (vm.currentTenantAsset != tenant) {
            vm.currentTenantAsset = tenant;
        }
        vm.ctx.stateController.openRightLayout();
        $rootScope.$broadcast('tenantAssetSelected', tenant.id);
    }

    function isCurrent(tenant) {
        return (vm.currentTenantAsset && tenant) &&
            (vm.currentTenantAsset.id.id === tenant.id.id);
    }

    function enterFilterMode() {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode() {
        vm.query.search = null;
        updateTenantAssets();
        vm.ctx.hideTitlePanel = false;
    }

    function onReorder() {
        updateTenantAssets();
    }

    function onPaginate() {
        updateTenantAssets();
    }

    function addTenantAsset($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: addSetupSettingsController,
            controllerAs: 'vm',
            templateUrl: addSetupSettingsTemplate,
            parent: angular.element($document[0].body),
            locals: {},
            fullscreen: true,
            skipHide: true,
            targetEvent: $event,
            onComplete: function () {
                var w = angular.element($window);
                w.triggerHandler('resize');
            }
        }).then(function () {
            reloadTenantAssets();
        }, function () {
        });
    }

    function reloadTenantAssets() {
        vm.allTenantAssets.length = 0;
        vm.tenantAssets.length = 0;

        vm.tenantAssetPromise = assetService.getTenantAssets({limit: 99999}, false, null, agTypes.assetType.tenantInfo).then(
            (allAssets) => {
                vm.allTenantAssets = allAssets.data;
                updateTenantAssets();
                vm.devicesPromise = null;
            }, () => {
                vm.allTenantAssets = [];
                updateTenantAssets();
                vm.tenantAssetPromise = null;
            }
        );
    }

    function updateTenantAssets() {
        var result = $filter('orderBy')(vm.allTenantAssets, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.tenantAssetsCount = result.length;

        if (vm.displayPagination) {
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.tenantAssets = result.slice(startIndex, startIndex + vm.query.limit);
        } else {
            vm.tenantAssets = result;
        }
    }
}

/*@ngInject*/
function addSetupSettingsController($scope, $mdDialog, $filter, agSetupSettingsService) {

    var vm = this;

    var tenantTitlePrefix = "TN-";
    var tenantEmailSuffix = "_admin@supertech.dk";

    var userTitlePrefix = "TN-";
    var userEmailSuffix = "_user@supertech.dk";

    vm.add = add;
    vm.cancel = cancel;
    vm.titleChange = titleChange;
    vm.customerUserTitleChange = titleChange;

    vm.currentDate = new Date();
    vm.tenantUrl = "http://localhost:8080";
    vm.aerationCheckInterval = 60;
    vm.siloCheckInterval = 60;

    vm.passwordAdmin = generatePassword();
    vm.passwordUser = generatePassword();
    vm.daysBeforeWarning = 30;
    vm.endPaymentDate = 0;
    vm.billingInfo = {
        name: null,
        companyName: null,
        vatNumber: null,
        address: null,
        country: null,
        phoneNumber: null,
        email: null
    };

    function add() {
        var productionDateString = $filter('date')(vm.productionDate, 'ddMMyy');
        var batchNumString = pad(vm.batchNumber, 2);

        var setupSettings = {
            tenant: {},
            tenantAdmin: {
                email: vm.emailAdmin
            },
            customerUser: {
                email: vm.emailUser
            },
            tenantInfoAsset: {
                additionalInfo: {
                    description: vm.tenantDescription
                }
            },
            customer: {
                daysBeforeWarning: vm.daysBeforeWarning,
                endPaymentDate: Date.parse(vm.endPaymentDate),
                additionalInfo: {
                    billingInfo: vm.billingInfo
                },
            },
            tenantUserPassword: vm.passwordAdmin,
            customerUserPassword: vm.passwordUser,
            url: vm.tenantUrl,
            aerationCheckIntervalInSec: vm.aerationCheckInterval,
            siloCheckIntervalInSec: vm.siloCheckInterval
        };

        setupSettings.tenant.title = tenantTitlePrefix + productionDateString + "-" + batchNumString;
        setupSettings.tenantInfoAsset.name = setupSettings.tenant.title;

        agSetupSettingsService.addSetupSettings(setupSettings).then(
            function () {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            }
        );
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function titleChange() {
        if (vm.productionDate && vm.batchNumber) {
            var productionDateString = $filter('date')(vm.productionDate, 'ddMMyy');
            var batchNumString = pad(vm.batchNumber, 2);

            vm.emailAdmin = tenantTitlePrefix + productionDateString + "-" + batchNumString + tenantEmailSuffix;
            vm.emailUser = userTitlePrefix + productionDateString + "-" + batchNumString + userEmailSuffix;
        }
    }

    function generatePassword() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        for (var i = 0; i < 12; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }

    function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }
}
